// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText___2Oh_","RichText--WhiteOnBlue":"RichText_RichText--WhiteOnBlue__eeBFJ"};